import React from "react";
import { reduxForm, Field, reset } from "redux-form";
import { connect } from "react-redux";
import * as agent from "../agent";
import * as queryString from "query-string";
import { LoanStatuses, NewLoanTypes, DenialReasons } from "../constants/enums";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import { formatPhone } from "../utility";
import { FormattedDate, FormattedTime, FormattedNumber } from "react-intl";
import Preloader from './Preloader';
import InnerLink from './InnerLink';
import SubmitButton from './SubmitButton';
import MaterialDatePicker from './MaterialDatePicker';
import { MaterialTextField } from "./MaterialInput";
import TablePaginationActions from "./TablePaginationActions";
import SmsForm from "./SmsForm";
import Button from '@material-ui/core/Button';
import PrimaryDivider from './PrimaryDivider';
import InputAdornment from '@material-ui/core/InputAdornment';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Fade from '@material-ui/core/Fade';
import Chip from '@material-ui/core/Chip';
import Badge from '@material-ui/core/Badge';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import throttle from "lodash/throttle";
import theme from "../constants/theme";
const { red, green, yellow, grey, white } = theme.palette;

const statusStyles = { "DRAFT": grey, "SECURITY_CHECK": yellow, "APPROVED": green, "DENIED": red };

class Accordeon extends React.Component {

    state = {
        contract: {},
        contractLoaded: false,
        client: this.props.client,
        showModal: false
    }

    componentDidMount = () => this.fetchData();

    fetchData = () => {
        const { accordeonOpened, client: {cars: {contract, loan: {status}}} } = this.props;
        if(accordeonOpened && status === "APPROVED" && contract) {
            this.setState({ contractLoaded: false });
            agent.Contract.get(contract)
                .then(res => this.setState({
                    contractLoaded: true,
                    contract: res.contract
                }))
                .catch(err => alert(err.message));
        } else {
            this.setState({ contractLoaded: true });
        }
    };
    onAddComment = (id, details) => {
        agent.Clients.addComment(id, details)
            .then(res => {
                const {cars} = this.state.client;
                const car = res.client.cars.find(c => c._id == cars._id);
                const updClient = Object.assign({}, res.client, {cars: car})
                this.setState({ client: updClient })
            })
            .catch(e => alert(e.message))
    }
    onDeleteComment = (carId, commentId) => {
        agent.Clients.deleteComment(carId, commentId)
            .then(res => {
                const {cars} = this.state.client;
                const car = res.client.cars.find(c => c._id == cars._id);
                const updClient = Object.assign({}, res.client, {cars: car})
                this.setState({ client: updClient })
            })
            .catch(e => alert(e.message))
    }
    handleClick = (e) => {
        e.preventDefault();
        this.setState({ showModal: true})
    }
    handleClose = () => this.setState({ showModal: false});

    render() {
        const { contractLoaded, contract, client, showModal } = this.state;
        const { userPermissions } = this.props;
        const { firstname = "—", secondname = "—", thirdname = "—", birthDate = "—", phone, cars = {} } = client || {};
        const { clientDetails = {}, carDetails = {}, programDetails: {sum, rates = []} = {} } = contract || {};
        const { _id: carId, brand, model, year, vin = "—", loan: { value, phoneCalls = []} } = cars || {};
        const fName = clientDetails.firstname || firstname;
        const sName = clientDetails.lastname || secondname;
        const tName = clientDetails.patronymic || thirdname;
        
        return contractLoaded ?
            <Fade in={contractLoaded}>
                <div className="inner-accordeon">
                    <Grid container justify="center" spacing={8}>
                        <Grid item xs={2}>
                            <Typography>Фамилия: { sName }</Typography>
                            <Typography>Имя: { fName }</Typography>
                            <Typography>Отчество: { tName }</Typography>
                            <Typography>Дата рождения: { clientDetails.birthDate || birthDate }</Typography>
                            <Typography>Телефон: {formatPhone(clientDetails.phone || phone)}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography>Автомобиль: {`${carDetails.brand || brand} ${carDetails.model || model}`}</Typography>
                            <Typography>Год выпуска: {carDetails.year || year}</Typography>
                            <Typography>VIN: {carDetails.vin || vin}</Typography>
                            <Typography>Гос. номер: {carDetails.registryNumber || "—"}</Typography>
                            <IconButton onClick={this.handleClick}>
                                <MailOutlineIcon />
                            </IconButton>
                            {showModal &&
                                <Dialog maxWidth={false} open={showModal} onClose={this.handleClose}>
                                    <SmsForm client={`${sName} ${fName[0]}. ${tName[0]}.`} phone={clientDetails.phone || phone} />
                                </Dialog>
                            }
                        </Grid>
                        <Grid item xs={2}>
                            <Typography>Сумма займа: {<FormattedNumber value={sum || value}
                                                                       style={`currency`}
                                                                       currency="RUB"
                                                                       minimumFractionDigits={0} />}
                            </Typography>
                            <Typography>Ставки: {rates.length > 0 ? `${rates.join("%, ")}%` : "—"}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                        {phoneCalls.length > 0 &&
                            <Table padding="checkbox">
                                <TableHead >
                                    <TableRow >
                                        <TableCell>Дата</TableCell>
                                        <TableCell>Автор</TableCell>
                                        <TableCell>Комментарий</TableCell>
                                        {userPermissions.includes("client-comment-delete") && <TableCell>&nbsp;</TableCell>}
                                    </TableRow >
                                </TableHead >
                            <TableBody >
                                {phoneCalls.map(({_id, date, author = {}, text}, i) =>
                                    <TableRow key={i}>
                                        <TableCell>
                                            <FormattedDate value={date}
                                                           day="numeric"
                                                           month="numeric"
                                                           year="numeric" />
                                            <br />
                                            <FormattedTime value={date}
                                                           hour="numeric"
                                                           minute="numeric"
                                                           second="numeric" />
                                        </TableCell>
                                        <TableCell>
                                            {author.fullname.split(" ")[0]}
                                        </TableCell>
                                        <TableCell>
                                            {text}
                                        </TableCell>
                                        {userPermissions.includes("client-comment-delete") &&
                                            <TableCell>
                                                <IconButton onClick={() => this.onDeleteComment(carId, _id)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        }
                                    </TableRow>
                                )}
                            </TableBody >
                        </Table>}
                            <AddCommentForm id={carId} onAddComment={this.onAddComment}/>
                        </Grid>
                    </Grid>
                </div>
            </Fade> : <Preloader size="l" />
    }
}

const addCommentForm = ({id, onAddComment, handleSubmit}) => (
    <form className="accordeon-comment-form" onSubmit={handleSubmit(data => onAddComment(id, data))}>
        <Field name="text"
               multiline
               label="Комментарий"
               component={MaterialTextField} />
        <SubmitButton label="Добавить"/>
    </form>
);

const AddCommentForm = reduxForm({
    form: "add-comment-form",
    onSubmitSuccess: (result, dispatch) => dispatch(reset("add-comment-form"))
})(addCommentForm);

class ClientsTable extends React.Component {

    constructor(props) {
        super(props);

        const parsedParams = queryString.parse(window.location.search, {arrayFormat: "bracket"});
        const { currentPage = 0, startDate, endDate, statuses = [], searchQuery = "", sortedField, asc } = parsedParams;

        this.state = {
            sortedField: sortedField || window.localStorage.getItem("clientsSortedField") || "date",
            asc: +asc || -1,
            clients: [],
            openedLoans: [],
            totalClients: 0,
            clientsLoaded: false,
            currentPage,
            statuses: statuses.length ? statuses : ["DENIED"],
            searchQuery,
            startDate: startDate ? new Date(+startDate) : null,
            endDate: endDate ? new Date(+endDate) : new Date(),
        }
    }

    componentDidMount() {
        this.fetchClients();
    }
    fetchClients = () => {
        this.setState({ clientsLoaded: false });
        const { currentPage, sortedField, asc, searchQuery = "", statuses, startDate, endDate } = this.state;
        const criteria = Object.assign(
            { currentPage, sortedField, asc, statuses },
            startDate ? { startDate: startDate.valueOf() } : {},
            endDate ? { endDate: endDate.valueOf() } : {},
            searchQuery.length > 1 ? { searchQuery } : {}
        );
        agent.Clients.all(criteria)
            .then(res => this.setState({
                clients: res.clients,
                totalClients: res.total,
                clientsLoaded: true
            }))
            .then(() => {
                window.history.pushState(
                    { foo: "bar" },
                    "title",
                    `?${queryString.stringify({
                        currentPage,
                        sortedField,
                        statuses,
                        asc,
                        searchQuery: searchQuery.length ? searchQuery : void 0,
                        startDate: startDate ? +startDate : void 0,
                        endDate: endDate ? +endDate : void 0
                    }, {arrayFormat: "bracket"})}`
                );
            })
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    onAddComment = (id, details) => {
        const { clients } = this.state;
        agent.Clients.addComment(id, details)
            .then(res => this.setState({ clients: clients.map(c => c._id === res.client._id ? res.client : c ) }))
            .catch(e => alert(e.message))
    }
    onDeleteComment = (carId, commentId) => {
        const { clients } = this.state;
        agent.Clients.deleteComment(carId, commentId)
            .then(res => this.setState({ clients: clients.map(c => c._id === res.client._id ? res.client : c ) }))
            .catch(e => alert(e.message))
    }

    turnPage = (e, p) => {
        this.setState({ currentPage: p }, () => this.fetchClients());
    }
    toggleAccordeon = (id) => {
        const { openedLoans } = this.state;
        this.setState({ openedLoans: openedLoans.includes(id) ? openedLoans.filter(o => o !== id) : openedLoans.concat(id) });
    }
    toggleStatus = (status) => {
        const { statuses } = this.state;
        this.setState({ currentPage: 0, statuses: statuses.includes(status) ? statuses.filter(s => s !== status) : statuses.concat(status) }, () => this.fetchClients());
    }
    throttledSearchClients = throttle(() => this.fetchClients(), 500)
    searchClients = (e) => {
        const query = e.target.value;
        this.setState({ searchQuery: query }, this.throttledSearchClients);
    }
    clearSearch = () => {
        this.setState({ searchQuery: "" }, () => this.fetchClients());
    }
    sortTable = (f) => {
        const { sortedField, asc } = this.state;
        window.localStorage.setItem("clientsSortedField", f);
        this.setState({ sortedField: f, asc: sortedField === f ? -1 * asc : asc }, () => this.fetchClients());
    }
    onStartDateChange = date => {
        this.setState({ startDate: new Date(date) }, () => this.fetchClients());
    }
    onEndDateChange = date => {
        this.setState({ endDate: new Date(date) }, () => this.fetchClients());
    }

    render() {
        const { endDate, startDate, clientsLoaded, statuses, clients, totalClients, currentPage, sortedField, asc, openedLoans, searchQuery } = this.state;
        const { userPermissions } = this.props;
        const showExtra = userPermissions.includes("contracts-extra");
        const showLink = userPermissions.includes("client");

        const columns = Object.assign(
            { "date": "Дата", "num": "Номер" },
            ( showExtra ? { "manager": "Менеджер" } : {}),
            { "number": "Телефон", "fullname": "ФИО", "car": "Автомобиль", "year": "Год", "office": "Офис", "program": "Программа", "sum": "Сумма", "docs": "", "status": "Статус" },
            ( !statuses.includes("DENIED") ? { "denial": "Причины отказа" } : {}),
        );

        return (
            <Fade in={true}>
                <React.Fragment>
                    <Typography variant="h4">Заявки</Typography>
                    <PrimaryDivider />
                    <Grid container justify="center" spacing={8}>
                        <Grid item>
                            <Grid container justify="flex-start" spacing={8}>
                                <Grid item>
                                    <MaterialDatePicker label="Начало периода" value={startDate} onChange={this.onStartDateChange} />
                                </Grid>
                                <Grid item>
                                    <MaterialDatePicker label="Конец периода" value={endDate} onChange={this.onEndDateChange} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container item alignItems="center" xs>
                            <Grid container justify="center" spacing={8} >
                            {["DRAFT", "SECURITY_CHECK", "APPROVED", "DENIED"].map((s, i) =>
                                <Grid  key={i} item>
                                    <Button style={ statuses.includes(s) ? white : statusStyles[s] }
                                            variant="contained"
                                            onClick={() => this.toggleStatus(s)} >
                                        {LoanStatuses[s]}
                                    </Button>
                                </Grid>
                            )}
                            </Grid>
                        </Grid>
                        <Grid item style={{ width: 250 }}>
                            <TextField label="Поиск"
                                       helperText="Введите фамилию, номер заявки или телефон"
                                       fullWidth
                                       InputLabelProps={{ shrink: true }}
                                       FormHelperTextProps={{ classes: {root: "input-double-error"} }}
                                       value={searchQuery}
                                       InputProps={ searchQuery.length > 0 ? {
                                           endAdornment: (
                                               <InputAdornment position="end">
                                                   <IconButton onClick={this.clearSearch}>
                                                        <HighlightOffIcon />
                                                   </IconButton>
                                               </InputAdornment> )
                                       } : {} }
                                       onChange={this.searchClients}
                                       variant="outlined"
                                       padding="dense"
                                       margin="dense" />
                        </Grid>
                    </Grid>
                    {clientsLoaded ?
                        <Fade in={clientsLoaded}>
                            <Table padding="checkbox" style={{ marginTop: 10, marginBottom: 10 }}>
                                <TableHead >
                                    <TableRow >
                                        {Object.keys(columns).map((column, i) => {
                                            return (
                                                <TableCell key={i} >
                                                    <TableSortLabel active={sortedField === column}
                                                                    direction={asc === 1 ? "asc" : "desc"}
                                                                    onClick={() => this.sortTable(column)} >
                                                        {columns[column]}
                                                    </TableSortLabel>
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    {clients.map((client, i) => {
                                        const { _id: clientId,
                                                firstname = "—",
                                                secondname = "",
                                                thirdname = "",
                                                cars = {},
                                                phone = "",
                                                isJuridicalPerson,
                                                carsLength,
                                                carsClosedLength,
                                                user = [] } = client;
                                        const { _id: carId,
                                                createdAt,
                                                brand,
                                                model,
                                                year,
                                                number_id,
                                                loan: { status, office, type, value, denialReasons = [], denialSource } = {},
                                                docs = [] } = cars;
                                        const withDocs = ["car", "licence", "registrationCertificate", "passport", "acceptConditions"]
                                            .concat(isJuridicalPerson ? ["statuteScan", "INN", "order"] : [])
                                            .every(doc => (docs[doc]||[]).length > 0);
                                        const [managerLastname, managerFirstname = " ", managerThirdname = " " ] = ((user[0]||{}).fullname||"").split(" ");
                                        const renderStatus = LoanStatuses[status] || "???";
                                        const formattedPhone = formatPhone(phone);
                                        const substatus = <span className={`status-circle`} title={withDocs ? "С документами": "Без документов"}>{withDocs ? "✔" : ""}</span>
                                        const accordeonOpened = openedLoans.includes(carId);
                                        const { managerReasons, clientReasons } = DenialReasons;
                                        const loanNumber = ("0".repeat(6) + number_id).slice(-6);
                                        return (
                                            <React.Fragment key={i}>
                                                <TableRow hover={true} onClick={() => this.toggleAccordeon(carId)}>
                                                    <TableCell >
                                                        <FormattedDate value={createdAt}
                                                                       day="numeric"
                                                                       month="numeric"
                                                                       year="numeric" />
                                                    </TableCell>
                                                    <TableCell>
                                                        { showLink ? <InnerLink href={`/client/${clientId}/car/${carId}`} label={loanNumber} /> : loanNumber }
                                                    </TableCell>
                                                    {showExtra &&
                                                        <TableCell>{`${managerLastname} ${managerFirstname[0]}. ${managerThirdname[0]}.`}</TableCell>
                                                    }
                                                    <TableCell>
                                                        {formattedPhone}
                                                    </TableCell>
                                                    <TableCell>
                                                        {(`${secondname} ${firstname} ${thirdname}`).trim().toUpperCase()}
                                                    </TableCell>
                                                    <TableCell>
                                                        {`${brand} ${model}`}
                                                    </TableCell>
                                                    <TableCell>
                                                        {year}
                                                    </TableCell>
                                                    <TableCell>
                                                        {{"NEWCHERKASSKY":"НВЧ","MOSCOW":"МСК","NOT_SURE":"—"}[office]}
                                                    </TableCell>
                                                    <TableCell>
                                                        {NewLoanTypes[type] || "—"}
                                                    </TableCell>
                                                    <TableCell>
                                                        <FormattedNumber value={value}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </TableCell>
                                                    <TableCell padding="none">
                                                        {substatus}
                                                    </TableCell>
                                                    <TableCell >
                                                        {carsLength && carsLength > 1 ?
                                                            <Tooltip title={`${carsClosedLength} закрытых договоров из ${carsLength} обращений`}>
                                                                <Badge badgeContent={`${carsClosedLength}`} color="primary">
                                                                    <Chip style={statusStyles[status]} label={renderStatus} />
                                                                </Badge>
                                                            </Tooltip>
                                                            :
                                                            <Chip style={statusStyles[status]} label={renderStatus} />
                                                        }

                                                    </TableCell>
                                                    {!statuses.includes("DENIED") &&
                                                        <TableCell >
                                                            {status === "DENIED" ?
                                                                <React.Fragment>
                                                                    <Typography>Источник: {{"CLIENT": "Клиент", "MANAGER": "Менеджер"}[denialSource]}</Typography>
                                                                    <Typography>Причины:</Typography>
                                                                    {denialReasons.map((r, i) => (
                                                                        <Typography key={i}>- {(denialSource === "MANAGER" ? managerReasons[r] : clientReasons[r]) || r}</Typography>
                                                                    ))}
                                                                </React.Fragment>
                                                                :
                                                                "—"
                                                            }
                                                        </TableCell>
                                                    }
                                                </TableRow>
                                                {accordeonOpened &&
                                                    <Fade in={accordeonOpened}>
                                                        <TableRow >
                                                            <TableCell colSpan={14}>
                                                                <Accordeon userPermissions={userPermissions}
                                                                           client={client}
                                                                           onAddComment={this.onAddComment}
                                                                           onDeleteComment={this.onDeleteComment}
                                                                           accordeonOpened={accordeonOpened} />
                                                            </TableCell>
                                                        </TableRow>
                                                    </Fade>
                                                }
                                            </React.Fragment>
                                        )}
                                    )}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TableCell colSpan={20}>
                                            <Grid container justify="center">
                                                <TablePagination count={totalClients}
                                                                 labelDisplayedRows={({ from, to, count }) => `${from}-${to} из ${count}`}
                                                                 rowsPerPage={20}
                                                                 rowsPerPageOptions={[]}
                                                                 page={currentPage}
                                                                 onChangePage={this.turnPage}
                                                                 ActionsComponent={TablePaginationActions} />
                                             </Grid>
                                         </TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </Fade> : <Preloader />}
                </React.Fragment>
            </Fade>
        );
    }
};

const mapStateToProps = (state) => ({
    userPermissions: state.common.user.permissions
});

export default connect(mapStateToProps, null)(ClientsTable);



// WEBPACK FOOTER //
// ./src/components/ClientsTable.js